import {
  createPlugin,
  createComponentExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const automaticDeploymentPlugin = createPlugin({
  id: 'automatic-deployment',
  routes: {
    root: rootRouteRef,
  },
});

export const AutomaticDeploymentComponent = automaticDeploymentPlugin.provide(
  createComponentExtension({
    name: 'AutomaticDeploymentComponent',
    component: {
      lazy: () =>
        import('./components/AutomaticDeploymentComponent').then(
          m => m.AutomaticDeploymentComponent,
        ),
    },
  }),
);
